import ServicePageTemplate from "@/components/ServicePageTemplate";
import { Helmet } from "react-helmet-async";
import { Globe, ShoppingCart, Store, Search, Server, Zap } from "lucide-react";

const subServices = ["E-commerce Sites", "Local Business Sites", "SEO & Hosting"];

const features = [
  {
    icon: ShoppingCart,
    title: "E-commerce Sites",
    description: "Custom Shopify, WooCommerce, and WordPress stores built for conversion and sales.",
  },
  {
    icon: Store,
    title: "Local Business Sites",
    description: "Professional websites for local businesses that attract customers and build trust.",
  },
  {
    icon: Search,
    title: "SEO Optimization",
    description: "Search engine optimization to help you rank higher and get found by customers.",
  },
  {
    icon: Server,
    title: "Reliable Hosting",
    description: "Fast, secure hosting solutions that keep your site running smoothly 24/7.",
  },
  {
    icon: Zap,
    title: "Performance Focused",
    description: "Lightning-fast load times and optimized code for the best user experience.",
  },
  {
    icon: Globe,
    title: "Mobile Responsive",
    description: "Every site looks perfect on all devices - desktop, tablet, and mobile.",
  },
];

const benefits = [
  {
    title: "Conversion Optimized",
    description: "Every element is designed to turn visitors into paying customers.",
  },
  {
    title: "SEO Built-In",
    description: "Your site is built with search engines in mind from day one.",
  },
  {
    title: "Ongoing Support",
    description: "We don't just build and disappear. Get continuous support and updates.",
  },
  {
    title: "Platform Expertise",
    description: "Deep knowledge of Shopify, WordPress, and modern web technologies.",
  },
];

const process = [
  {
    title: "Strategy",
    description: "Understanding your business goals and target audience.",
  },
  {
    title: "Design",
    description: "Creating a custom design that reflects your brand perfectly.",
  },
  {
    title: "Development",
    description: "Building your site with clean, optimized, scalable code.",
  },
  {
    title: "Launch",
    description: "Testing, optimization, and smooth launch with ongoing support.",
  },
];

export default function Web() {
  return (
    <>
      <Helmet>
        <title>Website Design & Development | Professional Websites from £299 | Barton</title>
        <meta name="description" content="Custom website design and development for small businesses. Mobile-responsive, SEO-friendly websites starting from £299. Free consultations available." />
        <meta property="og:title" content="Website Design & Development | Barton" />
        <meta property="og:description" content="Custom websites for small businesses. Mobile-responsive, SEO-friendly websites starting from £299." />
        <meta property="og:url" content="https://barton.uk/services/web" />
        <meta property="og:image" content="https://barton.uk/og-image.png" />
        <meta name="twitter:title" content="Website Design & Development | Barton" />
        <meta name="twitter:description" content="Custom websites for small businesses starting from £299." />
        <meta name="twitter:image" content="https://barton.uk/og-image.png" />
      </Helmet>
      <ServicePageTemplate
        title="Web"
        subtitle="Websites That Convert"
        description="From e-commerce powerhouses to local business sites, we build websites that look stunning and drive real results for your business."
        image="https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80"
        icon={Globe}
        features={features}
        benefits={benefits}
        process={process}
        subServices={subServices}
        ctaText="Get In Touch"
        accentColor="blue"
      />
    </>
  );
}
